import { getTotalPrice } from '../../../../utils';
export function getSeatPrice(seat) {
    var _a;
    if ((_a = seat.seatServices) === null || _a === void 0 ? void 0 : _a.length) {
        const canAddedServices = seat.seatServices.filter(service => service.canBeAdded);
        if (canAddedServices.length) {
            return getTotalPrice(canAddedServices, service => service.price);
        }
    }
    return seat.price;
}
